// extracted by mini-css-extract-plugin
export default {"textboxContainer":"styles_textboxContainer__dxP9J"};